<template>
  <div ref="ranking" class="page ranking">
    <router-view />
    <div class="fixed-search">
      <div class="ranking-search-btn">
        <div class="ranking-search-btn-main" @click="toSearch">
          <div class="ranking-search-btn-text">
            <van-icon class="ranking-search-btn-icon" name="search" />
            基金代码/名称/投顾产品名称
          </div>
        </div>
      </div>
    </div>
    <van-pull-refresh
      class="ranking-list"
      v-model="refreshing"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="0"
      >
        <van-sticky
          class="sticky-bar"
          :container="container"
        >
          <div v-if="option && option.length" class="ranking-filter-type">
            <div class="ranking-filter-type-main">
              <div class="ranking-filter-type-main-zw"></div>
              <div
                v-for="item in option"
                :key="item.value"
                class="ranking-filter-type-item"
                :class="{
                  'text-theme-color': filterValue === item.value
                }"
                @click="changeFilter(item)"
              >
                {{item.text}}
                <i class="bg-theme-color"></i>
              </div>
              <div class="ranking-filter-type-main-zw"></div>
            </div>
          </div>
          <van-row class="ranking-sticky-bar-row">
            <van-col span="11">
              <div class="ranking-sticky-bar-name ranking-sticky-bar-name1">
                基金简称/代码
              </div>
            </van-col>
            <template  v-if="filterValue === '1109'">
              <van-col span="5">
                <div class="ranking-sticky-bar-name" style="text-align: center;">
                  万份收益
                </div>
              </van-col>
              <van-col span="8">
                <div class="ranking-sticky-bar-name" style="text-align: right">
                  七日年化
                </div>
              </van-col>
            </template>
            <template v-else>
              <van-col span="5">
                <div class="ranking-sticky-bar-name" style="text-align: center;">
                  最新净值
                </div>
              </van-col>
              <van-col span="8">
                <van-dropdown-menu ref="changeDesc">
                  <van-dropdown-item>
                    <template #title>
                      {{descStrMap[desc]}}
                      <van-icon name="filter-o" />
                    </template>
                    <van-cell class="ranking-sticky-drapdown-item" center v-for="item in descsMap" :key="item.value" :title="item.name" @click="changeDesc(item)">
                      <template #right-icon>
                        <van-image
                          v-if="item.value === desc"
                          width="18px"
                          height="18px"
                          fit="cover"
                          :src="require('@/assets/images/icon/check-true-02.png')"
                        />
                        <van-image
                          v-else
                          width="18px"
                          height="18px"
                          fit="cover"
                          :src="require('@/assets/images/icon/check-false.png')"
                        />
                      </template>
                    </van-cell>
                  </van-dropdown-item>
                </van-dropdown-menu>
              </van-col>
            </template>
          </van-row>
        </van-sticky>
        <van-cell v-for="item in list" :key="item.fundCode" class="ranking-item" @click="toDetail(item)">
          <van-row class="ranking-item-row">
            <van-col span="11">
              <div class="ranking-item-span ranking-item-span1">
                <div>
                  <div class="fund-name">{{item.fundName}}</div>
                  <div class="fund-code">{{item.fundCode}}</div>
                </div>
              </div>
            </van-col>
            <van-col span="5">
              <div style="display: block;text-align: center;" class="ranking-item-span" v-if="filterValue === '1109'">
                <div class="fund-num">{{item.hfIncomeRatio}}</div>
                <div class="fund-date">{{item.navDate}}</div>
              </div>
              <div style="display: block;text-align: center;" class="ranking-item-span" v-else>
                <div class="fund-num">{{item.navUnit}}</div>
                <div class="fund-date">{{item.navDate}}</div>
              </div>
            </van-col>
            <van-col span="8">
              <div class="ranking-item-span ranking-item-span2" v-if="filterValue === '1109'">
                <div
                  v-if="item.incomeRatio"
                  class="fund-price"
                  :class="{
                    add: parseFloat(item.incomeRatio) > 0,
                    min: parseFloat(item.incomeRatio) < 0
                  }"
                >{{parseFloat(item.incomeRatio) > 0 ? '+' : ''}}{{item.incomeRatio}}</div>
                <div v-else class="fund-price">--</div>
              </div>
              <div class="ranking-item-span ranking-item-span2" v-else>
                <div
                  v-if="item.fundListSortFieldValue"
                  class="fund-price"
                  :class="{
                    add: parseFloat(item.fundListSortFieldValue) > 0,
                    min: parseFloat(item.fundListSortFieldValue) < 0
                  }"
                >{{parseFloat(item.fundListSortFieldValue) > 0 ? '+' : ''}}{{item.fundListSortFieldValue}}</div>
                <div v-else class="fund-price fund-price-none">--</div>
              </div>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {
  fetchDictBizDictionary,
  fetchSingleProductFundList
} from '@/api'
import {
  isInPZAPP,
  pzOpenNativePage,
  getVersion
} from '@/utils/bridge'

export default {
  name: 'FundRanking',
  data () {
    return {
      filterValue: '',
      option: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      query: {
        current: 1,
        size: 10
      },
      descsMap: [
        {
          name: '近一周涨幅',
          value: 'F_AVGRETURN_WEEK'
        },
        {
          name: '近一月涨幅',
          value: 'F_AVGRETURN_MONTH'
        },
        {
          name: '近三月涨幅',
          value: 'F_AVGRETURN_QUARTER'
        },
        {
          name: '近六月涨幅',
          value: 'F_AVGRETURN_HALFYEAR'
        },
        {
          name: '近一年涨幅',
          value: 'F_AVGRETURN_YEAR'
        },
        {
          name: '近两年涨幅',
          value: 'F_AVGRETURN_TWOYEA'
        },
        {
          name: '近三年涨幅',
          value: 'F_AVGRETURN_THREEYEAR'
        },
        {
          name: '成立以来涨幅',
          value: 'F_AVGRETURN_SINCEFOUND'
        }
      ],
      descStrMap: {
        F_AVGRETURN_WEEK: '近一周涨幅',
        F_AVGRETURN_MONTH: '近一月涨幅',
        F_AVGRETURN_QUARTER: '近三月涨幅',
        F_AVGRETURN_HALFYEAR: '近六月涨幅',
        F_AVGRETURN_YEAR: '近一年涨幅',
        F_AVGRETURN_TWOYEA: '近两年涨幅',
        F_AVGRETURN_THREEYEAR: '近三年涨幅',
        F_AVGRETURN_SINCEFOUND: '成立以来涨幅'
      },
      desc: 'F_AVGRETURN_YEAR',
      total: -1,
      searchNameMap: {
        CommonIndexHome: 'FundRankingSearch',
        CommonIndexRanking: 'CommonIndexRankingSearch',
        CommonIndexRankingSteady: 'CommonIndexRankingSteadySearch',
        CommonIndexRankingAdvance: 'CommonIndexRankingAdvanceSearch'
      },
      queryFundRiskLevelMap: {
        CommonIndexRankingSteady: '0,1,2',
        CommonIndexRankingAdvance: '3,4'
      },
      staticEnv1: {
        CommonIndexRankingSteady: 'robustinvestmentpage_show',
        CommonIndexHome: 'publicofferingist_show',
        CommonIndexRankingAdvance: 'advancedInvestmentpage_show'
      },
      staticEnv2: {
        CommonIndexRankingSteady: 'robustinvestmentpage_typetab',
        CommonIndexHome: 'publicofferingist_tab',
        CommonIndexRankingAdvance: 'advancedInvestmentpage_typetab'
      },
      staticEnv3: {
        CommonIndexRankingSteady: 'robustinvestmentpage_product',
        CommonIndexHome: 'publicofferingist_product',
        CommonIndexRankingAdvance: 'advancedInvestmentpage_product'
      },
      tabs: {
        CommonIndexRankingSteady: ['1207', '1105', '1109'],
        CommonIndexRankingAdvance: ['1103', '1206', '1101', '1202', '1110']
      },
      container: null
    }
  },
  created () {
    const pageName = this.$route.name
    if (pageName === 'CommonIndexRankingSteady') {
      this.filterValue = '1207'
    }
    if (pageName === 'CommonIndexRankingAdvance') {
      this.filterValue = '1103'
    }
  },
  mounted () {
    this.init()
    this.static(this.staticEnv1[this.$route.name])
    this.container = this.$refs.ranking
  },
  methods: {
    init () {
      let _option = []
      fetchDictBizDictionary({
        code: 'Fund_Type_In_Front'
      }).then((res) => {
        if (res.code === 200) {
          _option = res.data || []
          _option = _option.map((item) => {
            return {
              text: item.dictValue,
              value: item.dictKey
            }
          })
        }
        _option.unshift({
          text: '全部',
          value: null
        })
        const pageName = this.$route.name
        if (pageName === 'CommonIndexRankingSteady' || pageName === 'CommonIndexRankingAdvance') {
          const arr = _option.filter(item => {
            return this.tabs[pageName].includes(item.value)
          })
          this.option = arr
        } else {
          this.option = _option
        }
        if (this.option.length) {
          this.filterValue = this.option[0].value
        }
      })
    },
    onLoad () {
      let _list = [...this.list]
      let _query
      if (this.filterValue === '1109') {
        _query = {
          ...this.query,
          fundType: this.filterValue
        }
      } else {
        _query = {
          ...this.query,
          descs: this.desc,
          fundType: this.filterValue
        }
      }
      if (this.queryFundRiskLevelMap[this.$route.name]) {
        _query.fundRiskLevel = this.queryFundRiskLevelMap[this.$route.name]
      }
      fetchSingleProductFundList(_query).then((res) => {
        this.loading = false
        if (res.code === 200) {
          this.total = res.data.total
          const _data = res.data.records || []
          _list = _list.concat(_data)
          this.query.current += 1
          if (this.list.length >= this.total) {
            this.finished = true
          }
        } else {
          this.$toast(res.msg)
          this.finished = true
        }
        this.list = _list
      }).catch(() => {
        this.finished = true
      })
    },
    onRefresh () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.finished = false
      this.loading = true
      this.list = []
      this.query.current = 1
      this.desc = 'F_AVGRETURN_YEAR'
      this.total = -1
      this.onLoad()
    },
    changeFilter (item) {
      this.finished = false
      this.loading = true
      this.list = []
      this.query.current = 1
      this.total = -1
      this.filterValue = item.value
      this.onLoad()
      this.static(this.staticEnv2[this.$route.name], {
        FunctionName: item.text
      })
    },
    changeDesc (item) {
      // console.log(item.name)
      this.static('publicofferingist_pricetab', {
        FunctionName: item.name
      })
      this.desc = item.value
      this.finished = false
      this.loading = true
      this.list = []
      this.query.current = 1
      try {
        this.$refs.changeDesc.toggleItem(false)
      } catch (e) {}
      this.onLoad()
    },
    async toSearch () {
      const env = this.$route.name === 'CommonIndexRankingSteady' ? 'robustinvestmentpage_searchbox' : 'advancedInvestmentpage_searchbox'
      this.static(env, {
        FunctionName: '搜索'
      })
      if (isInPZAPP) {
        const uNo = getVersion()
        if (uNo && uNo >= 320) {
          pzOpenNativePage({
            page: '/fund_search_page'
          })
        } else {
          this.$router.push({
            name: this.searchNameMap[this.$route.name]
          })
        }
      } else {
        this.$router.push({
          name: this.searchNameMap[this.$route.name]
        })
      }
    },
    toDetail (item) {
      this.static(this.staticEnv3[this.$route.name], {
        FunctionName: item.fundName,
        Property1: item.id
      })
      if (item.newFund) {
        // 新发基金
        this.$router.push({
          name: 'newFundDetail',
          query: {
            fundCode: item.fundCode
          }
        })
      } else if (this.filterValue === '1109') {
        // 货币基金
        this.$router.push({
          name: 'CurrencyFundDetail',
          query: {
            fundCode: item.fundCode
          }
        })
      } else {
        // 普通基金
        this.$router.push({
          name: 'FundDetail',
          query: {
            fundCode: item.fundCode
          }
        })
      }
    },
    static (type, data) {
      this.$static(type, {
        page_name: '稳健投资',
        name: 'CommonIndexRankingSteady',
        ...data
      })
    }
  }
}
</script>

<style scoped lang="less">
.ranking {
  background: #FFFFFF;
  position: relative;
  width: 100%;
  height: 100%;
  color: var(--paragraph-text-color);
  overflow-x: hidden;
  overflow-y: auto;
  .fixed-search {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 11;
    .ranking-search-btn {
      padding: 22px 16px 7px 16px;
      .ranking-search-btn-main {
        height: 30px;
        border-radius: 30px;
        background: #F9F9F9;
        .ranking-search-btn-text {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: var(--font-size-sub-body);
          color: var(--secondary-background-color);
          .ranking-search-btn-icon {
            font-size: var(--font-size-title);
            margin-right: 8px;
          }
        }
      }
    }
  }
  &.isclose {
    overflow: hidden;
  }
  .sticky-bar {
    .ranking-filter-type {
      background: #FFFFFF;
      height: 44px;
      width: 100%;
      overflow: hidden;
      border-bottom: 1px solid #EFEFEF;
      .ranking-filter-type-main {
        height: 64px;
        font-size: 0;
        white-space: nowrap;
        overflow-x: auto;
        .ranking-filter-type-main-zw {
          display: inline-block;
          width: 4px;
          height: 44px;
          overflow: hidden;
        }
        .ranking-filter-type-item {
          white-space: nowrap;
          display: inline-block;
          position: relative;
          height: 44px;
          line-height: 44px;
          padding: 0 12px;
          color: var(--secondary-tittle-color);
          font-size: var(--font-size-sub-body);
          vertical-align: top;
          font-weight: var(--font-weight-bold);
          i {
            display: none;
            position: absolute;
            left: 50%;
            bottom: 0;
            width: 28px;
            height: 3px;
            border-radius: 3px;
            margin-left: -14px;
          }
          &.text-theme-color {
            i {
              display: block;
            }
          }
        }
      }
    }
    .ranking-sticky-bar-row{
      background: #FFFFFF;
      align-items: center;
      display: flex;
      padding: 0 8px;
      .ranking-sticky-bar-name {
        font-size: var(--font-size-tips);
        color: var(--tips-text-color);
        padding: 0 6px;
        &.ranking-sticky-bar-name {
          padding-left: 8px;
        }
      }
      /deep/ .van-dropdown-menu__title {
        font-size: var(--font-size-tips);
        color: var(--tips-text-color);
        padding-right: 8px;
        text-align: right;
        width: 100%;
        &:after {
          display: none;
        }
      }
    }
    .sticky-nav-filter {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: right;
      .filter-icon {
        font-size: var(--font-size-title);
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: 0 0 0;
    }
    /deep/ .ranking-sticky-bar-name {
      height: 48px;
      line-height: 48px;
    }
    .ranking-sticky-drapdown-item {
      /deep/.van-cell__title {
        font-size: var(--font-size-special-body);
      }
    }
  }
  .ranking-list {
    background: #ffffff;
    padding-top: 59px;
    padding-bottom: 1px;
    min-height: 100%;
    .ranking-item {
      padding: 16px 8px;
      display: flex;
      align-items: center;
      .ranking-item-row {
        display: flex;
        align-items: center;
      }
      .ranking-item-span {
        padding: 0 6px;
        display: flex;
        &.ranking-item-span1 {
          padding-left: 8px;
        }
        &.ranking-item-span2 {
          padding-right: 8px;
        }
      }
    }
    .fund-sort {
      width: 17px;
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      font-size: var(--font-size-sub-body);
    }
    .fund-name {
      line-height: 20px;
      flex: 1;
      font-size: var(--font-size-sub-body);
      font-weight: var(--font-weight-bold);
    }
    .fund-code {
      line-height: 20px;
      font-size: var(--font-size-tips);
      color: var(--tips-text-color);
      font-weight: normal;
    }
    .fund-num {
      line-height: 20px;
      font-size: var(--font-size-sub-body);
    }
    .fund-date {
      line-height: 20px;
      font-size: var(--font-size-tips);
      color: var(--tips-text-color);
    }
    .fund-price {
      text-align: right;
      font-size: var(--font-size-sub-title);
      line-height: 20px;
      flex: 1;
      &.add {
        color: var(--danger-color);
      }
      &.min {
        color: var(--safe-color);
      }
      &.fund-price-none {
        color: var(--tips-text-color);
      }
    }
  }
  .search-module {
    padding-top: 60px;
  }
}
</style>
